import { render, staticRenderFns } from "./addFeedBack.vue?vue&type=template&id=4bde2c3a&scoped=true&"
import script from "./addFeedBack.vue?vue&type=script&lang=js&"
export * from "./addFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./addFeedBack.vue?vue&type=style&index=0&id=4bde2c3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bde2c3a",
  null
  
)

export default component.exports